import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { useToast } from '../../hooks/useToast';

interface ShareAccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ShareAccessModal({ isOpen, onClose }: ShareAccessModalProps) {
  const { showToast } = useToast();
  const url = window.location.origin;

  const copyUrl = () => {
    navigator.clipboard.writeText(url).then(() => {
      showToast('Portal URL copied to clipboard!');
    }).catch(() => {
      showToast('Failed to copy URL');
    });
  };

  return (
    <Modal id="share-access" isOpen={isOpen} onClose={onClose} title="Share Portal Access" size="sm">
      <div className="space-y-4">
        <p className="text-sm text-[var(--text-muted)]">
          Share this URL with other inspectors on the same LAN network to access the portal.
        </p>
        <div className="flex items-center gap-2">
          <input
            type="text"
            className="input-field font-mono text-sm flex-1"
            value={url}
            readOnly
          />
          <Button variant="primary" size="sm" onClick={copyUrl}>Copy</Button>
        </div>
        <div className="flex justify-end pt-2">
          <Button variant="secondary" onClick={onClose}>Close</Button>
        </div>
      </div>
    </Modal>
  );
}
